export default "__VITE_ASSET__98Wr$r$5__"